import ChevronComponent from "@/tpo/Chevron";
import { ActionIcon } from "@/v2/Buttons";

export default function CircleButton({
  onClick,
  direction,
  iconHeight,
  iconWidth,
  disabled,
  arrowColor,
  sx,
  bg = "haze",
  border,
  borderColor
}) {
  return (
    <ActionIcon
      size={["sm", "sm", "md"]}
      bg={bg}
      border={border}
      borderColor={borderColor}
      variant="circle"
      onClick={onClick}
      disabled={disabled}
      sx={sx}
    >
      <ChevronComponent
        fill={arrowColor}
        style={{
          margin: 0
        }}
        height={iconHeight}
        width={iconWidth}
        direction={direction}
      />
    </ActionIcon>
  );
}

CircleButton.defaultProps = {
  arrowColor: "dark"
};
